import { useEffect, useRef, useState } from "react";
import { sub_users, verify_root } from "../../../server/requests";
import { useRouter } from "../../../hooks/router";
import Slider from "react-slick";

import ErrorImgSubUser from "../../Util/img";

import "./SubUsers.scss";

import default_sub_img from "../images/user_default.png";
import { translateWord, crypt } from "../../Util/util";
import Loading from "../../Loading/Loading";

export default function SubUsers({ callBackUser, appSettings }) {
  const router = useRouter();

  const [subUsersList, setSubUsersList] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const [showSubAddButton, setShowSubAddButton] = useState(false);
  const parentListSubUsers = useRef();

  const settings = {
    className: "slider variable-width",
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 9,
    slidesToScroll: 9,
    variableWidth: true,
  };

  useEffect(() => {
    setShowLoading(true);
    sub_users(
      {},
      (data) => {
        localStorage.setItem("root_id", data[0].id);
        setSubUsersList([...data]);

        if (
          !appSettings.max_sub_users_count ||
          data.length <= appSettings.max_sub_users_count
        ) {
          setShowSubAddButton(true);
        }

        const shouldAutoSignIn =
          localStorage.getItem("sub_users_disabled") ||
          data.length === 1 ||
          sessionStorage.getItem("auto_signing_in") ||
          (router.query.a && router.query.token && router.query.userId);

        if (
          shouldAutoSignIn
        ) {
          let body;

          if (router.query.a && router.query.token && router.query.userId) {
            let active_user = data.find((e) => e.id == router.query.userId);
            if (active_user) {
              body = {
                password: active_user.password,
                id: active_user.id,
              };
              callBackUser(active_user);
            } else {
              sessionStorage.removeItem("auto_signing_in");
              router.push("/");
              return;
            }
          } else {
            body = {
              password: data[0].is_protected ? data[0].password : "",
              id: data[0].id,
            };
            callBackUser(data[0]);
          }

          verify_root(
            body,
            (data) => {
              sessionStorage.removeItem("auto_signing_in");
              localStorage.setItem("token", crypt("token", data));

              if (router.query.a && router.query.token && router.query.userId)
                router.push(`/settings?a=payment`);
              else router.push("/");
            },
            (err) => {
              sessionStorage.removeItem("auto_signing_in");
              setShowLoading(false);
            },
          );
        } else {
          setShowLoading(false);
        }
      },
      (err) => {
        sessionStorage.removeItem("auto_signing_in");
        if (err == "User not found") {
          let device_id = localStorage.getItem("device_id");
          localStorage.clear();
          localStorage.setItem("device_id", device_id);
          router.push("/auth");
        }
        setShowLoading(false);
        // let active_lang = JSON.parse(localStorage.getItem('language'))
        // let background = localStorage.getItem('background_image')
        // let device_id = localStorage.getItem('device_id')
        // localStorage.clear()
        // localStorage.setItem('language', JSON.stringify(active_lang))
        // localStorage.setItem('background_image', background)
        // localStorage.setItem('device_id', device_id)
        // router.push('/auth')
        // console.log(err, 'err')
      },
    );
  }, []);

  const btn_sub_user = (subUser) => {
    callBackUser(subUser);
    if (!subUser.is_protected) {
      const body = {
        password: "",
        id: subUser.id,
      };
      verify_root(body, (data) => {
        localStorage.setItem("token", crypt("token", data));
        setTimeout(() => {
          router.push("/");
        }, 500);
      });
    } else {
      router.push("/subusers/verify");
    }
  };

  return (
    <>
      {showLoading ? (
        <Loading />
      ) : (
        <div className={"sub_users_list_parent"} ref={parentListSubUsers}>
          <h1 className="title_sub_users">
            {translateWord("who will watching?", "Who will watching?")}
          </h1>
          <div
            className="sub_users_list"
            // ref={listSubUsers}
            style={
              subUsersList.length > 8
                ? null
                : {
                    width: `${subUsersList.length * 19 + 15}rem`,
                    display: "flex",
                    justifyContent: "space-around",
                  }
            }
          >
            {subUsersList.length > 8 ? (
              <Slider {...settings}>
                {subUsersList.map((e, i) => {
                  return (
                    <div
                      style={{ width: 180 }}
                      className={"sub_users"}
                      key={i}
                      onClick={() => btn_sub_user(e)}
                    >
                      <ErrorImgSubUser
                        src={window._HOST_ + "/" + e.image}
                        placeholder={default_sub_img}
                        className="image_sub_user"
                      />
                      <h3 className="name_sub_user">{e.name}</h3>
                    </div>
                  );
                })}
                <div
                  className={"add_subUser"}
                  onClick={() => router.push("/subusers/create-subuser")}
                >
                  <span>+</span>
                </div>
              </Slider>
            ) : (
              <>
                {subUsersList.map((e, i) => {
                  return (
                    <div
                      style={{ width: "17rem" }}
                      className={"sub_users_card"}
                      key={i}
                      onClick={() => btn_sub_user(e)}
                    >
                      <ErrorImgSubUser
                        src={window._HOST_ + "/" + e.image}
                        placeholder={default_sub_img}
                        className="image_sub_user"
                      />
                      <h3 className="name_sub_user">{e.name}</h3>
                    </div>
                  );
                })}
                {showSubAddButton && (
                  <div
                    className={"add_subUser"}
                    onClick={() => router.push("/subusers/create-subuser")}
                  >
                    <span>+</span>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
